var _rect, _rect2, _text, _text2, _text3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRawaajLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 400,
    height: 80,
    viewBox: "0 0 400 80",
    role: "img",
    "aria-label": "Rawaaj Mall",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Rawaaj Mall") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 8,
    width: 64,
    height: 64,
    rx: 16,
    fill: "#cc9966"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 8,
    width: 64,
    height: 64,
    rx: 16,
    fill: "none",
    stroke: "#fcb941",
    strokeWidth: 3
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 34,
    y: 55,
    textAnchor: "middle",
    fontFamily: "Poppins, 'Segoe UI', Arial, sans-serif",
    fontSize: 40,
    fontWeight: 800,
    fill: "#ffffff"
  }, "R")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 80,
    y: 52,
    fontFamily: "Poppins, 'Segoe UI', Arial, sans-serif",
    fontSize: 34,
    fontWeight: 800,
    letterSpacing: 2,
    fill: "#a0703f"
  }, "RAWAAJ")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 270,
    y: 52,
    fontFamily: "Poppins, 'Segoe UI', Arial, sans-serif",
    fontSize: 34,
    fontWeight: 600,
    letterSpacing: 2,
    fill: "#cc9966"
  }, "MALL")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRawaajLogo);
export default __webpack_public_path__ + "static/media/rawaaj-logo.f1c3882262ed4fd8d8364b7eba1b7771.svg";
export { ForwardRef as ReactComponent };